import React, { useState } from "react";
import watchVideo from "../../assets/images/watchVideo.png";
import lpBlue from "../../assets/images/stuff/lpBlue.svg";
import lpOrange from "../../assets/images/stuff/lpOrange.svg";
import useLocalStorageState from "use-local-storage-state";
import purplePlay from "../../assets/images/purplePlay.svg";
import yellowPlay from "../../assets/images/yellowPlay.svg";
import BorderDashed from "./BorderDashed/BorderDashed";

function InsideOfSecondPart({
  phase,
  setPhase,
  setVideoPhaseSecondWeek,
  videoPhaseSecondWeek,
  videosWatchedFirstWeek,
  seen1,
  seen2,
  seen3,
  seen4,
  timestamps,
  today,
  setShowDialog,
  setDialogContent,
  allContent,
}) {
  const [yellowButtonTwo, setYellowButtonTwo] = useState(0);
  const [yellowButtonTwo2, setYellowButtonTwo2] = useState(0);

  const [seenMeme3, setSeenMeem3] = useLocalStorageState("seenMeme3", false);
  const [seenMeme4, setSeenMeem4] = useLocalStorageState("seenMeme4", false);

  const poster21 = seen3 ? allContent.week2.posterMeme1 : watchVideo;
  const poster22 = seen4 ? allContent.week2.posterMeme2 : watchVideo;
  const meme21 = allContent.week2.gif1;
  const meme22 = allContent.week2.gif2;

  return (
    <div
      className={(() => {
        switch (true) {
          case phase === 1 && today > timestamps[1]:
          case phase === 3:
            return "firstDescribe";
          default:
            return "displayNone";
        }
      })()}
    >
      <div className="InsideOfFirstPartHolder">
        <div
          className={today < timestamps[1] ? "iofpLeft blackText" : "iofpLeft"}
        >
          <div className="describeContainerAll">
            <p>{allContent.week2.episode}</p>
            <h2>
              {allContent.week2.title.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </h2>
            <p className="inEpisodes">{allContent.week2.description}</p>
          </div>
          <button
            className={(() => {
              switch (true) {
                case phase === 1 && today > timestamps[1] && !(seen3 && seen4):
                case phase === 2.5 && !(seen3 && seen4):
                  return "mainButtonApp";
                default:
                  return "displayNone";
              }
            })()}
            onClick={() => {
              setPhase(3);
            }}
          >
            {allContent.openNow}
          </button>
          <button
            className={(() => {
              switch (true) {
                case phase === 1 && seen3 && seen4:
                case phase === 2.5 && seen3 && seen4:
                case phase === 3.5 && seen3 && seen4:
                case phase === 4.5 && seen3 && seen4:
                case phase === 5.5 && seen3 && seen4:
                  return "openAgainButton";
                default:
                  return "displayNone";
              }
            })()}
            onClick={() => {
              setPhase(3);
            }}
          >
            {allContent.openAgain}
          </button>
        </div>
        <div
          className={(() => {
            switch (true) {
              case phase === 3:
                return "iofpRight2";
              default:
                return "displayNone";
            }
          })()}
        >
          <div className="imageHolder">
            <div
              id="RAM_BTN_Week2_Video1"
              onClick={() => {
                setVideoPhaseSecondWeek(1);
                setYellowButtonTwo(1);
              }}
              className="videoImageHolder"
            >
              <img
                src={allContent.week2.thumbnailImg1}
                alt="slide21"
                className="videoShow"
              />
              <p className="textVideoShow">
                {allContent.week2.thumbnailTitle1}
              </p>
              <img
                src={seen3 ? yellowPlay : purplePlay}
                alt="playButton"
                className="playButton"
              />
            </div>
            <div className={"imageHeight memeContainer"}>
              <div className={"grayOverlayMemeAll"}>
                {seen3 && (
                  <div
                    onPointerDown={() => {
                      if (seen3) {
                        setShowDialog(true);
                        setSeenMeem3(true);
                        setDialogContent({
                          type: "meme",
                          meme: meme21,
                        });
                      }
                    }}
                    className={(() => {
                      switch (true) {
                        case seenMeme3:
                          return "displayNone";
                        case seen3:
                          return "grayOverlayMemeAllIn";
                      }
                    })()}
                  >
                    <p>
                      {allContent.clickToOpen.split("\n").map((line, index) => (
                        <React.Fragment key={index}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                    </p>
                  </div>
                )}
                {!seen3 && <BorderDashed />}
                {seen3 && (
                  <img
                    src={poster21}
                    alt="meme1"
                    width={"100%"}
                    onPointerDown={() => {
                      if (seen3) {
                        setShowDialog(true);
                        setSeenMeem3(true);
                        setDialogContent({
                          type: "meme",
                          meme: meme21,
                        });
                      }
                    }}
                  />
                )}                
                {seen3 && (
                  <img
                    className={"lupaAll"}
                    src={seenMeme3 ? lpOrange : lpBlue}
                    alt="lp"
                  />
                )}
              </div>
            </div>
          </div>
          <div className="imageHolder">
            <div
              id="RAM_BTN_Week2_Video2"
              onClick={() => {
                setVideoPhaseSecondWeek(2);
                setYellowButtonTwo2(1);
              }}
              className="videoImageHolder"
            >
              <img
                src={allContent.week2.thumbnailImg2}
                alt="slide22"
                className="videoShow"
              />
              <p className="textVideoShow">
                {allContent.week2.thumbnailTitle2}
              </p>
              <img
                src={seen4 ? yellowPlay : purplePlay}
                alt="playButton"
                className="playButton"
              />
            </div>

            <div className={"imageHeight memeContainer"}>
              <div className={"grayOverlayMemeAll"}>
                {seen4 && (
                  <div
                    onPointerDown={() => {
                      if (seen4) {
                        setShowDialog(true);
                        setSeenMeem4(true);
                        setDialogContent({
                          type: "meme",
                          meme: meme22,
                        });
                      }
                    }}
                    className={(() => {
                      switch (true) {
                        case seenMeme4:
                          return "displayNone";
                        case seen4:
                          return "grayOverlayMemeAllIn";
                      }
                    })()}
                  >
                    <p>
                      {allContent.clickToOpen.split("\n").map((line, index) => (
                        <React.Fragment key={index}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                    </p>
                  </div>
                )}
                {!seen4 && <BorderDashed />}
                {seen4 && (
                  <img
                    src={poster22}
                    alt="meme4"
                    width={"100%"}
                    onPointerDown={() => {
                      if (seen4) {
                        setShowDialog(true);
                        setSeenMeem4(true);
                        setDialogContent({
                          type: "meme",
                          meme: meme22,
                        });
                      }
                    }}
                  />
                )}                
                {seen4 && (
                  <img
                    className={"lupaAll"}
                    src={seenMeme4 ? lpOrange : lpBlue}
                    alt="lp"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InsideOfSecondPart;
